<page-headline
    [linkTitle]="'Financials Insights'"
    [module]="'financials'"
    [moduleIcon]="'fa-dollar-sign'"
    [moduleLink]="'financials/insights'"
    [pageTitle]="'Financials Option'"
>
</page-headline>
<p>
    This page is a placeholder.
</p>
